module.exports = __webpack_public_path__ + "static/media/AD.abb4ef0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AD.svg
// module id = 2093
// module chunks = 7